import { ReactElement, useState } from 'react'
import { Tooltip } from '@mui/material'

function ToolTipEllipsis({
  text,
  children
}: {
  text: string
  children: ReactElement
}): JSX.Element {
  const [open, setOpen] = useState<boolean>(false)

  return (
    <Tooltip
      open={open}
      arrow
      title={text}
      onMouseOver={ev => {
        const title: HTMLDivElement = ev.target as HTMLDivElement
        setOpen(title.scrollWidth > title.clientWidth || title.scrollHeight > title.clientHeight)
      }}
      onMouseLeave={() => setOpen(false)}
    >
      {children}
    </Tooltip>
  )
}

export default ToolTipEllipsis
